const OrderTabs = ({ activeTab, handleTabChange }) => {
  return (
    <div className="flex items-center font-inter font-medium text-[15px] gap-4 sm:gap-6 border-b border-gray-300 overflow-x-auto scrollbar-none whitespace-nowrap">
      <div
        className={`flex items-center px-4 py-2 cursor-pointer ${
          activeTab === "" ? "border-b-2 border-primary" : ""
        }`}
        onClick={() => handleTabChange("all")}
      >
        <span
          className={`${
            activeTab === "" ? "font-bold" : "font-medium"
          } text-gray-900 sm:text-lg`}
        >
          All
        </span>
      </div>
      <div
        className={`flex items-center px-4 py-2 cursor-pointer ${
          activeTab === "ongoing" ? "border-b-2 border-primary" : ""
        }`}
        onClick={() => handleTabChange("ongoing")}
      >
        <span
          className={`${
            activeTab === "ongoing" ? "font-bold" : "font-medium"
          } text-gray-900 sm:text-lg`}
        >
          Ongoing
        </span>
      </div>
      <div
        className={`flex items-center px-4 py-2 cursor-pointer ${
          activeTab === "completed" ? "border-b-2 border-primary" : ""
        }`}
        onClick={() => handleTabChange("completed")}
      >
        <span
          className={`${
            activeTab === "completed" ? "font-bold" : "font-medium"
          } text-gray-900 sm:text-lg`}
        >
          Completed
        </span>
      </div>
    </div>
  );
};

export default OrderTabs;
